import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import { Location} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { LargeImageDialogComponent } from "../../shared/components/large-image-dialog/large-image-dialog.component";
import { CmsService } from "../../shared/services/cms.service";
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {SeoService} from "../../shared/services/seo.service";
import {Subscription} from "rxjs";
import {filter, map} from "rxjs/operators";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'mbnm-gallery',
  providers: [ CmsService ],
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit, OnDestroy {

  pageData: any;
  currentSlug: string;

  private navSubscription: Subscription;
  private routeParamSubscription: Subscription;

  @Input()
  title:string = 'Gallery';

  constructor(public dialog: MatDialog,
              private cms: CmsService,
              private router: Router,
              private route: ActivatedRoute,
              private location: Location,
              public seoService:SeoService) {

  }

  ngOnInit() {

    this.navSubscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        map(event => event as NavigationStart)
      )
      .subscribe(
        event => {
          if (event.url.startsWith('/customer-art/')) {
            const  imageParts = event.url.split('/');
            const lastImagePart = imageParts[imageParts.length-1];
            this.activateImage(parseInt(lastImagePart));
          }
        }
      );

    this.routeParamSubscription = this.route.params
      .subscribe(params => {
        this.currentSlug = params['slug'];
        this.pageData = null;

        this.cms
          .pageChildren(this.currentSlug, '/customer-art')
          .then((pageData) => {
            if (!pageData) {
              this.router.navigateByUrl('/not-found');
              return;
            }
            this.pageData = pageData;
            this.activateImage(params['id'] ? parseInt(params['id'].split('-')[0]) : null);
          });
      });
  }

  activateImage(currentImageId) {
    const getCurrentImageById = (imageId) => {
      if (!this.pageData) {
        throw new Error("Can't set meta data if pageData is not yet loaded.");
      }

      let currentImage = this.pageData.images ? this.pageData.images.filter( (data:any) => {
        return data.id === imageId;
      })[0] : null;
      if (!currentImage && this.pageData.children) {
        this.pageData.children.forEach( (child) => {
          if (child.images && !currentImage) {
            currentImage = child.images.filter( (data:any) => data.id === imageId)[0];
          }
          if (currentImage) return;
        });
      }
      return currentImage;
    }
    const setMetaData = (currentImage) => {
      if (!this.pageData) {
        throw new Error("Can't set meta data if pageData is not yet loaded.");
      }
      if (currentImage) {
        this.seoService.setMetaData({
          title: currentImage.title + ' - ' + this.pageData.pageTitle,
          description: currentImage.title + ' - ' + this.pageData.metaDescription,
          og: {
            image: currentImage.image
          },
          link: environment.baseUrls().site + currentImage.link
        });
      } else {
        let firstImage = this.pageData.images[0]?.image;
        if (!firstImage) {
          firstImage = this.pageData.children[0]?.images[0]?.image;
        }

        // reset meta data after close
        this.seoService.setMetaData({
          title: this.pageData.pageTitle,
          description: this.pageData.metaDescription,
          og: {
            image: firstImage
          }
        });
      }
    }
    const currentImage = getCurrentImageById(currentImageId);
    if (currentImage) {
      this.dialog
        .open(LargeImageDialogComponent, {
          data: currentImage
        })
        .afterClosed().subscribe(result => {
          this.location.go('/customer-art/' + this.currentSlug);
          setMetaData(null);
        });
      setMetaData(currentImage);
    } else if (currentImageId) {
      this.router.navigateByUrl('/not-found',{ skipLocationChange: true });
    } else {
      setMetaData(null);
    }
  }

  ngOnDestroy() {
    if (this.navSubscription && !this.navSubscription.closed) {
      this.navSubscription.unsubscribe();
    }

    if (this.routeParamSubscription && !this.routeParamSubscription.closed) {
      this.routeParamSubscription.unsubscribe();
    }

    this.dialog.closeAll();
  }
}
